import AUTOSYNC_EXT_1 from "./AUTOSYNC_EXT_1";

export default {
  AUTOSYNC_EXT_1,
};
